module.exports = generateBrands();

function generateBrands() {
	const fonts = {
		thalia: [

		],
		oft: [
			"/assets/fonts/LatoLatin-Regular.woff2",
			"/assets/fonts/LatoLatin-Bold.woff2"
		],
		osiander: [

		],
		buecher: [
			"/assets/fonts/JosefinSans-Regular.woff",
			"/assets/fonts/JosefinSans-Bold.woff",
			"/assets/fonts/PlayfairDisplay-Variable.woff2",
		],
		// E-Reader: drei Geraetegenerationen mit Chrome 30 / 61 / 108 brauchen
		// drei verschiedene Playfair-Dateien - ein Preload wuerde fuer zwei davon
		// eine ungenutzte Datei laden. Auswahl uebernimmt der @font-face-Fallback.
		buecherEreader: [
			"/assets/fonts/JosefinSans-Regular.woff",
			"/assets/fonts/JosefinSans-Bold.woff",
		]
	};
	return {
		"brands": {
			"2": {
				"beschreibung": "www.thalia.de",
				"touchpoint": "web",
				"name": "thalia",
				"brandcode": "TDE",
				"preloadFonts": fonts.thalia,
				"usercentrics": true,
				"kameleoon": true,
				"analyticsMeasurementId": "G-E9KFHF4FDJ",
				"analyticsMeasurementIdStaging": "G-YR5VVE1G1T",
				"robotsTxt": "robots.txt",
				"sitemaps": [
					"https://www.thalia.de/sitemaps/kategorie/kategorie.xml",
					"https://www.thalia.de/sitemaps/artikel/artikel.xml",
					"https://www.thalia.de/sitemaps/autoren/autoren.xml",
					"https://www.thalia.de/sitemaps/themenwelt/themenwelt.xml",
					"https://www.thalia.de/sitemaps/images/image_sitemap_index.xml"
				]
			},
			"2003": {
				"beschreibung": "app.thalia.de",
				"touchpoint": "app",
				"appCallbackProtocol": "thaliaxcapp",
				"name": "thalia",
				"brandcode": "TDE",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "G-L0H659604T",
				"analyticsMeasurementIdStaging": "G-ESXN0310TE",
				"robotsTxt": "robots-app.txt",
				"sitemaps": []
			},
			"2004": {
				"beschreibung": "ereader.thalia.de",
				"touchpoint": "ereader",
				"name": "thalia",
				"brandcode": "TDE",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "G-BKGQCYDRVJ",
				"analyticsMeasurementIdStaging": "G-5VTF2K2SE7",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
			"2005": {
				"beschreibung": "Tolino-App ?",
				"touchpoint": "app",
				"appCallbackProtocol": "epublishing",
				"name": "thalia",
				"brandcode": "TDE",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "",
				"analyticsMeasurementIdStaging": "",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
			"4": {
				"beschreibung": "www.thalia.at",
				"touchpoint": "web",
				"name": "thalia",
				"brandcode": "TAT",
				"preloadFonts": fonts.thalia,
				"usercentrics": true,
				"analyticsMeasurementId": "G-QZYCT0SFWG",
				"analyticsMeasurementIdStaging": "G-NVNYVC26F2",
				"robotsTxt": "robots.txt",
				"sitemaps": [
					"https://www.thalia.at/sitemaps/kategorie/kategorie.xml",
					"https://www.thalia.at/sitemaps/artikel/artikel.xml",
					"https://www.thalia.at/sitemaps/autoren/autoren.xml",
					"https://www.thalia.at/sitemaps/themenwelt/themenwelt.xml"
				]
			},
			"4002": {
				"beschreibung": "app.thalia.at",
				"touchpoint": "app",
				"appCallbackProtocol": "thaliaxcapp",
				"name": "thalia",
				"brandcode": "TAT",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "G-1DCRCRWVJ2",
				"analyticsMeasurementIdStaging": "G-SCMH2BLQ1B",
				"robotsTxt": "robots-app.txt",
				"sitemaps": []
			},
			"4003": {
				"beschreibung": "Tolino-App ?",
				"touchpoint": "app",
				"appCallbackProtocol": "epublishing",
				"name": "thalia",
				"brandcode": "TAT",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "",
				"analyticsMeasurementIdStaging": "",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
			"4004": {
				"beschreibung": "ereader.thalia.at",
				"touchpoint": "ereader",
				"name": "thalia",
				"brandcode": "TAT",
				"preloadFonts": fonts.thalia,
				"analyticsMeasurementId": "G-XVS49RYVVS",
				"analyticsMeasurementIdStaging": "G-5VTF2K2SE7",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
			"37": {
				"beschreibung": "www.orellfuessli.ch",
				"touchpoint": "web",
				"name": "oft",
				"brandcode": "OFT",
				"preloadFonts": fonts.oft,
				"usercentrics": true,
				"analyticsMeasurementId": "G-BE2W3ZY94G",
				"analyticsMeasurementIdStaging": "G-D4CLB2J7YX",
				"robotsTxt": "robots.txt",
				"sitemaps": [
					"https://www.orellfuessli.ch/sitemaps/kategorie/kategorie.xml",
					"https://www.orellfuessli.ch/sitemaps/artikel/artikel.xml",
					"https://www.orellfuessli.ch/sitemaps/autoren/autoren.xml",
					"https://www.orellfuessli.ch/sitemaps/themenwelt/themenwelt.xml"
				],
				"metaTags": [
					{ "name": "google-adsense-account", "content": "ca-pub-9106118065576001"}
				]
			},
			"37002": {
				"beschreibung": "app.orellfuessli.ch",
				"touchpoint": "app",
				"appCallbackProtocol": "thaliaoftpp",
				"name": "oft",
				"brandcode": "OFT",
				"preloadFonts": fonts.oft,
				"analyticsMeasurementId": "G-RWENHWBPYK",
				"analyticsMeasurementIdStaging": "G-K13GFE4PV6",
				"robotsTxt": "robots-app.txt",
				"sitemaps": []
			},
			"37004": {
				"beschreibung": "ereader.orellfuessli.ch",
				"touchpoint": "ereader",
				"name": "oft",
				"brandcode": "OFT",
				"preloadFonts": fonts.oft,
				"analyticsMeasurementId": "G-0VFTMZZRNY",
				"analyticsMeasurementIdStaging": "G-5VTF2K2SE7",
				"robotsTxt": "robots.txt",
				"sitemaps": []

			},
			"51": {
				"beschreibung": "www.osiander.de",
				"touchpoint": "web",
				"name": "osiander",
				"brandcode": "OSI",
				"preloadFonts": fonts.osiander,
				"usercentrics": true,
				"analyticsMeasurementId": "G-V6Q9265C3P",
				"analyticsMeasurementIdStaging": "G-Z3719R890R",
				"robotsTxt": "robots.txt",
				"sitemaps": [
					"https://www.osiander.de/sitemaps/kategorie/kategorie.xml",
					"https://www.osiander.de/sitemaps/artikel/artikel.xml",
					"https://www.osiander.de/sitemaps/autoren/autoren.xml",
					"https://www.osiander.de/sitemaps/themenwelt/themenwelt.xml"
				]
			},
			"51003": {
				"beschreibung": "app.osiander.de",
				"touchpoint": "app",
				"appCallbackProtocol": "thaliaxcapp",
				"name": "osiander",
				"brandcode": "OSI",
				"preloadFonts": fonts.osiander,
				"analyticsMeasurementId": "G-M0JVP8ENN6",
				"analyticsMeasurementIdStaging": "G-CSMMJ1BNJK",
				"robotsTxt": "robots-app.txt",
				"sitemaps": []
			},
			"51004": {
				"beschreibung": "ereader.osiander.de",
				"touchpoint": "ereader",
				"name": "osiander",
				"brandcode": "OSI",
				"preloadFonts": fonts.osiander,
				"analyticsMeasurementId": "G-GJ13KJGKHR",
				"analyticsMeasurementIdStaging": "G-5VTF2K2SE7",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
			"55": {
				"beschreibung": "www.buecher.de",
				"touchpoint": "web",
				"name": "buecher",
				"brandcode": "BDE",
				"preloadFonts": fonts.buecher,
				"usercentrics": true,
				"analyticsMeasurementId": "G-WZ3GDVZ7F2",
				"analyticsMeasurementIdStaging": "G-42Y3LLR1CE",
				"robotsTxt": "robots.txt",
				"sitemaps": [
					"https://www.buecher.de/sitemaps/kategorie/kategorie.xml",
					"https://www.buecher.de/sitemaps/artikel/artikel.xml",
					"https://www.buecher.de/sitemaps/autoren/autoren.xml",
					"https://www.buecher.de/sitemaps/themenwelt/themenwelt.xml"
				]
			},
			"55004": {
				"beschreibung": "ereader.buecher.de",
				"touchpoint": "ereader",
				"name": "buecher",
				"brandcode": "BDE",
				"preloadFonts": fonts.buecherEreader,
				"analyticsMeasurementId": "G-80TGXMJYR3",
				"analyticsMeasurementIdStaging": "G-5VTF2K2SE7",
				"robotsTxt": "robots.txt",
				"sitemaps": []
			},
		}
	};
}

